<template>
    <nav 
        class="pagination-container" 
        v-if="lastPage > 1"
    >
        <ul class="pagination">
            <li 
                class="page-item" 
                :class="{disabled: page === 1}"
            >
                <a 
                    href="#" 
                    @click.prevent="prevPage()" 
                    class="page-link"
                >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                </a>
            </li>
            <li 
                v-for="p of pages" 
                :key="p" 
                class="page-item" 
                :class="{active: p === page}"
            >
                <a 
                    href="#" 
                    @click.prevent="setPage(p)" 
                    class="page-link"
                >{{ p }}</a>
            </li>
            <li 
                class="page-item" 
                :class="{disabled: page === lastPage}"
            >
                <a 
                    href="#" 
                    @click.prevent="nextPage()" 
                    class="page-link"
                >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: {
        page: {
            type: Number,
            default: 1
        },
        lastPage: {
            type: Number,
            default: 1
        }
    },

    computed: {
        pages: function() {
            let pages = [];
            for (let i = 1; i <= this.lastPage; i++) {
                pages.push(i);
            }

            pages = pages.filter(page => {
                return (
                    page < 2 ||
                    (page == this.lastPage) ||
                    (page > this.page - 3 && page < this.page + 3)
                );
            });

            return pages;
        }
    },
    methods: {
        setPage: function(page) {
            this.$emit("pageChange", page);
        },

        nextPage: function() {
            if (this.page < this.lastPage) {
                this.setPage(this.page + 1);
            }
        },

        prevPage: function() {
            if (this.page > 1) {
                this.setPage(this.page - 1);
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PaginationComponent.vue